module.exports = new __parcel__URL__("ray-charles.fc0f0936.jpg").toString();